import { i18next } from '@frontend/i18n';
import { SelectableIcons } from '@frontend/shared';

export const labelMap: Record<SelectableIcons, string> = {
  location: i18next.t('Location', { ns: 'base' }),
  multiLocations: i18next.t('Switch Locations', { ns: 'base' }),
  notifications: i18next.t('Notification Center', { ns: 'base' }),
  profile: i18next.t('Profile', { ns: 'base' }),
  chat: i18next.t('Team Chat', { ns: 'base' }),
  taskTray: i18next.t('Task Tray', { ns: 'base' }),
  quickfill: i18next.t('Waitlist', { ns: 'base' }),
  schedulePulse: i18next.t('Schedule Pulse', { ns: 'base' }),
  chatV2: i18next.t('Team Chat', { ns: 'base' }),
  actions: i18next.t('Actions', { ns: 'base' }),
  taskCenter: i18next.t('Task Center', { ns: 'base' }),
} as const;
